import { render, staticRenderFns } from "./studentCourseLayout.vue?vue&type=template&id=74b4d456&scoped=true&"
import script from "./studentCourseLayout.vue?vue&type=script&lang=js&"
export * from "./studentCourseLayout.vue?vue&type=script&lang=js&"
import style0 from "./studentCourseLayout.vue?vue&type=style&index=0&id=74b4d456&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b4d456",
  null
  
)

export default component.exports